import gql from 'graphql-tag'
import {EgovProcedureStatuses, EgovProcedureSignRequirement} from 'consts/egovProcedureStatuses'

export interface QueryVariables {
  egovProcedureId: string
}

interface Attachment {
  id: string
  fileName: string
  fileUrl: string
  documentName: string
  printedMynumber: boolean
}

export const EGOV_PROCEDURE = gql`
  query ($egovProcedureId: ID!) {
    client {
      egovProcedure(egovProcedureId: $egovProcedureId) {
        id
        status
        formName
        procedureName
        signRequirement
        egovApplication {
          arriveId
          egovAccount {
            email
            egovIdp
            gbizidAccountType
          }
          officialDocuments {
            id
            allowedDate
            docDownloadExpiredDate
            docDownloadDate
          }
          notices {
            id
            issueDate
            noticeTitle
            noticeSentence
            isFileDownload
          }
          trackingLogStatus
        }
        procedureStatus {
          id
          employee {
            displayFirstName
            displayLastName
          }
        }
        office {
          id
          name
        }
        csvProcedure {
          id
          procedureName
          employees {
            id
            displayFirstName
            displayLastName
          }
        }
        attachments {
          id
          fileName
          fileUrl
          documentName
          printedMynumber
        }
      }
    }
  }
`

export interface QueryResult {
  client: {
    egovProcedure: EgovProcedure
  }
}

interface Employee {
  displayFirstName: string
  displayLastName: string
}

export interface EgovProcedure {
  id: string
  status: EgovProcedureStatuses
  formName: string
  procedureName: string
  signRequirement: EgovProcedureSignRequirement
  egovApplication: {
    arriveId: string
    egovAccount: {
      email: string
      egovIdp: string
      gbizidAccountType: string
    }
    officialDocuments: {
      id: string
      allowedDate: string
      docDownloadDate: string
      docDownloadExpiredDate: string
    }[]
    notices: {
      id: string
      issueDate: string
      noticeTitle: string
      noticeSentence: string
      isFileDownload: boolean
    }[]
    trackingLogStatus: 'SUCCESS' | 'INVALID_TOKEN' | 'ABORT' | 'TRACKING_LOG_STATUS_UNKNOWN'
  }
  procedureStatus: {
    id: string
    employee: Employee
  }
  office: {
    id: string
    name: string
  }
  csvProcedure: {
    id: string
    procedureName: string
    employees: [Employee]
  }
  attachments: Attachment[]
}

export const WITHDRAW_EGOV_PROCEDURE = gql`
  mutation withdrawEgovProcedure($egovProcedureId: ID!, $pin: String, $withdrawReason: String!) {
    withdrawEgovProcedure(input: {egovProcedureId: $egovProcedureId, pin: $pin, withdrawReason: $withdrawReason}) {
      egovProcedureId
    }
  }
`

export interface WithdrawResult {
  egovProcedureId: string
}
